import gql from "graphql-tag";

import EX_LAWYER from "./exLawyer";

const CHILDREN = gql`
  ${EX_LAWYER}
  fragment CHILDREN on Children {
    id
    birthDate
    startSchoolDate
    endSchoolDate
    claimAsDependent
    claimDeduction
    disabled
    firstName
    gender
    isDependent
    isOfRelationship
    priorRelationship
    guidelineMonths
    lastName
    middleName
    parenting
    supportedBy
    supportType
    supportAmount
    clientSupportAmount
    exSupportAmount
    supportDeductible
    childIncome
    school
    isOurClient
    isParty
    partySort
    lawyer {
      ...EX_LAWYER
    }
    createdAt
    updatedAt
  }
`;

export default CHILDREN;
